// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-badge {
  display: inline-block;
  padding: 2px 14px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-left: 8px;
  vertical-align: middle;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
  border: none;
}

.topic-badge.champion {
  background: linear-gradient(90deg, #23bd33 60%, #7be495 100%);
  color: #fff;
}

.topic-badge.challenger {
  background: linear-gradient(90deg, #ffa500 60%, #ffd580 100%);
  color: #fff;
}

.topic-badge.rookie {
  background: linear-gradient(90deg, #6e7485 60%, #bfc4d1 100%);
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/StudentPages/Practice/components/TopicItem.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb","sourcesContent":[".topic-badge {\n  display: inline-block;\n  padding: 2px 14px;\n  border-radius: 16px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  margin-left: 8px;\n  vertical-align: middle;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);\n  border: none;\n}\n\n.topic-badge.champion {\n  background: linear-gradient(90deg, #23bd33 60%, #7be495 100%);\n  color: #fff;\n}\n\n.topic-badge.challenger {\n  background: linear-gradient(90deg, #ffa500 60%, #ffd580 100%);\n  color: #fff;\n}\n\n.topic-badge.rookie {\n  background: linear-gradient(90deg, #6e7485 60%, #bfc4d1 100%);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
